
import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const hasRoleGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = route?.data['roles'] as string[];
  return auth.hasRole(requiredRoles).pipe(
    map(hasRole => {
      if (hasRole) {
        return true;
      } else {
        return router.createUrlTree(['/']);
      }
    })
  );
};
